import { render } from "./TestsRejectPopup.vue?vue&type=template&id=23228a30&scoped=true"
import script from "./TestsRejectPopup.vue?vue&type=script&lang=js"
export * from "./TestsRejectPopup.vue?vue&type=script&lang=js"

import "./TestsRejectPopup.vue?vue&type=style&index=0&id=23228a30&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23228a30"],['__file',"src/components/cases/TestsRejectPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23228a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23228a30', __exports__)) {
    console.log('reload')
    api.reload('23228a30', __exports__)
  }
  
  module.hot.accept("./TestsRejectPopup.vue?vue&type=template&id=23228a30&scoped=true", () => {
    console.log('re-render')
    api.rerender('23228a30', render)
  })

}


export default __exports__